import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CommonResponse } from 'src/app/models/commomResponse';
import { NotificationList, Notification } from 'src/app/models/notification';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpClient) {}

  sendNotification(data: Notification): Observable<CommonResponse> {
    return this.http.post<CommonResponse>(
      `${environment.base_url}sendNotification`,
      data
    );
  }

  getNotificationList(data: string): Observable<NotificationList> {
    return this.http
      .get<{
        data: NotificationList;
      }>(`${environment.base_url}getNotification?${data}`)
      .pipe(map(res => res.data));
  }

  /**
   * Fetch a single notification by id.
   * Backend implementations vary; this uses the existing `getNotification` endpoint with an id query param
   * and returns the first match.
   */
  getNotificationById(id: string): Observable<Notification | null> {
    return this.http
      .get<{
        data: NotificationList | { notification: Notification } | Notification;
      }>(`${environment.base_url}getNotification/${id}`)
      .pipe(
        map(res => {
          const data: any = (res as any)?.data ?? null;
          if (!data) {
            return null;
          }
          if (Array.isArray(data?.notification)) {
            return data.notification.find((n: Notification) => n?._id === id) ?? data.notification[0] ?? null;
          }
          if (data?.notification && !Array.isArray(data.notification)) {
            return data.notification as Notification;
          }
          if (data?._id) {
            return data as Notification;
          }
          return null;
        })
      );
  }

  /**
   * Update an existing notification.
   * If your backend uses a different endpoint (e.g. `editNotification/:id`), adjust here.
   */
  updateNotification(id: string, payload: Partial<Notification>): Observable<CommonResponse> {
    return this.http.put<CommonResponse>(
      `${environment.base_url}updateNotification/${id}`,
      payload
    );
  }

  deleteNotification(id: string): Observable<number> {
    return this.http
      .delete<{
        statusCode: number;
      }>(`${environment.base_url}deleteNotification/${id}`)
      .pipe(map(res => res.statusCode));
  }
}
